import React from "react";
import { Row, Col } from 'react-bootstrap';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useAppSelector } from "../../Hooks";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MoreInfo: React.FC = () => {
    const {t}  = useTranslation()
    const { footer } = useAppSelector(state => state.footer);
    console.log(footer, 'footer');
    const navigate = useNavigate()
    return (
        <div>
            <div>
                <section className='more-info'>
                    <div className="container">
                        <Row className="align-items-center">
                            <Col md={7}>
                                <div className="info-content">
                                    <h4 className="title">{t('footer.heading_title')}</h4>
                                    <p className="text">{t('footer.heading_subtitle')}</p>
                                </div>
                            </Col>
                            <Col md={5}>
                                <div className="info-btns">
                                    <button onClick={()=>navigate(footer?.getstarted_link)} className="btn btn-color">{t('footer.get_started')}</button>
                                    <button onClick={()=>navigate(footer?.contact_link)} className="btn btn-border">{t('footer.contact_us')}</button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>

        </div>
    )
}
export default MoreInfo;